import React from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Page from 'Components/Page';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { withStyles } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import Link from '@material-ui/core/Link';
import FormTextField from 'Components/FormTextField';
import Button from '@material-ui/core/Button';
import * as Regex from '../regex';

const styles = theme => ({
  container: {
    marginTop: 30,
  },
  button: {
    color: '#fff',
    display: 'block',
    textAlign: 'center',
    width: 150,
  },
  link: {
    marginTop: 20,
  },
});

function Login({ setActiveModal, classes, submitLoginWithFireBase, registerWithFirebase }) {
  const { register, handleSubmit, errors, watch } = useForm({
    defaultValues: {},
  });

  const handleResetModalOpen = () => {
    setActiveModal('resetPassword');
  };

  const onSubmit = async data => {
    const { email, password } = data;
    console.log('data is :: ', email, password);

    try {
      const loginRes = await submitLoginWithFireBase({
        email,
        password,
        returnPath: '/dashboard',
      });
      if (loginRes.type === 'LOGIN_ERROR') {
        alert(loginRes.payload.message);
        return;
      }
    } catch (err) {
      console.warn('Login server error: ', err);
      alert('Login connection error');
      return;
    }

    setActiveModal('none');
  };

  return (
    <Page hasNav={true}>
      <Container className={classes.container} component="main" maxWidth="sm">
        <Typography variant="h2" className={classes.login}>
          Login
        </Typography>

        <FormTextField
          fullWidth
          label="Email"
          name="email"
          margin="normal"
          required
          error={!!errors.email}
          helperText={errors.email && errors.email.message}
          inputRef={register({
            required: 'Provide your login email',
            pattern: {
              value: Regex.email,
              message: 'Provide a valid email address',
            },
          })}
          placeholder="Enter Email"
        />
        <FormTextField
          fullWidth
          label="Password"
          name="password"
          type="password"
          required
          error={!!errors.password}
          helperText={errors.password && errors.password.message}
          inputRef={register({
            required: 'Provide the password',
            minLength: {
              value: 5,
              message: 'Password too short',
            },
          })}
        />
        <Link className={classes.link} component="button" variant="body2" onClick={handleResetModalOpen}>
          Forgot password?{' '}
        </Link>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.button}
          component={Link}
          onClick={handleSubmit(onSubmit)}
          style={{ marginTop: 30, textDecoration: 'none' }}
        >
          Submit
        </Button>
        <br />
        <a className={classes.link} component="button" variant="body2" href="/signup">
          Or Sign Up?{' '}
        </a>
        <br />
      </Container>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitLoginWithFireBase: actions.submitLoginWithFireBase,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(connect(null, mapDispatchToProps)(withStyles(styles)(Login)));
